import { mapFromKpiAttachmentLocation, mapFromKpiAttachmentOverrides } from 'mappings/kpiAttachmentLocationMapping';
import { DocumentOutputPurpose } from 'models/documentOutputLocation';
import { KpiAttachmentLocationDTO, KpiAttachmentOverrideDTO } from 'models/dto/kpiAttachmentLocationDTO';
import KpiAttachmentLocation, { KpiAttachmentOverride } from 'models/kpiAttachmentLocation';
import AppError from 'utils/appError';
import http from './httpService';

// the task gives the folder name its task tokens; ensure finds or creates the folder, which the upload needs
const getLocationQuery = (taskId: number | undefined, ensure: boolean): string =>
  `?ensure=${ensure}${taskId !== undefined ? `&taskId=${taskId}` : ''}`;

export async function apiGetKpiAttachmentLocation(
  kpiId: number,
  taskId: number | undefined,
  ensure: boolean,
  accessToken: string,
): Promise<KpiAttachmentLocation> {
  try {
    const ar = await http.get<KpiAttachmentLocationDTO>(
      `/kpis/${kpiId}/attachment-location${getLocationQuery(taskId, ensure)}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromKpiAttachmentLocation(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/** The location of a task-local question of type Attachment, which has no KPI of its own. */
export async function apiGetFieldAttachmentLocation(
  fieldId: number,
  taskId: number | undefined,
  ensure: boolean,
  accessToken: string,
): Promise<KpiAttachmentLocation> {
  try {
    const ar = await http.get<KpiAttachmentLocationDTO>(
      `/tasktypes/fields/${fieldId}/attachment-location${getLocationQuery(taskId, ensure)}`,
      http.getRequestConfig(accessToken),
    );

    return mapFromKpiAttachmentLocation(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}

/** The KPIs and task-local questions with a category of their own. */
export async function apiGetKpiOverrides(accessToken: string): Promise<KpiAttachmentOverride[]> {
  try {
    const ar = await http.get<KpiAttachmentOverrideDTO[]>(
      `/settings/outputlocations/${DocumentOutputPurpose.KpiAttachments}/overrides`,
      http.getRequestConfig(accessToken),
    );

    return mapFromKpiAttachmentOverrides(ar.data);
  } catch (err) {
    throw AppError.fromApiError(err);
  }
}
